import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";



export interface DialogData {
  invoiceId: string;
  shipmentKey: string;
  shipmentData: Array<any>;
  store_id: string
}
@Component({
  selector: 'app-shipping-info',
  templateUrl: './shipping-info.component.html',
  styleUrls: ['./shipping-info.component.css']
})
export class ShippingInfoComponent implements OnInit {

  shippingInfoForm: FormGroup;
  items: FormArray;
  loading: false;
  public shippingMethods: Array<any> = [];
  selectedMethod: string;
  public quantityError = false;
  public printLabelUrl: string;
  shippingData: any = {};

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ShippingInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService) {
    this.shippingInfoForm = this.formBuilder.group({
      items: this.formBuilder.array([this.createItem()])
    });

  }

  ngOnInit() {
    if (this.data.shipmentKey) {
      this.selectedMethod = this.data.shipmentKey;
      this.getShippmentMethod();
    }
  }
  createItem(): FormGroup {
    return this.formBuilder.group({
      width: ['0', Validators.compose([Validators.required])],
      length: ['0', Validators.compose([Validators.required])],
      height: ['0', Validators.compose([Validators.required])],
      weight: ['0', Validators.compose([Validators.required])]

    });
  }

  addItem(): void {
    this.items = this.shippingInfoForm.get('items') as FormArray;
    this.items.push(this.createItem());
  }

  deleteListRow(index) {

    this.items.controls.splice(index, 1);
    this.shippingInfoForm.get('items').value.splice(index, 1);
  }

  isFieldValid(field: string) {
    return (
      !this.shippingInfoForm.get(field).valid &&
      this.shippingInfoForm.get(field).touched
    );
  }

  saveShippingInfo = function (postData) {
    this.loading = true;
    let apiName = "shipments/create";
    this.shippingData = {
      id: localStorage.getItem("userID"),      
      boxes: this.shippingInfoForm.get('items').value,
      shipping_method: this.selectedMethod
    }
    if (this.data.store_id) {
      this.shippingData.store_id = this.data.store_id;
      apiName = "store/shipment";
    }
    else{
      this.shippingData.invoice_id= this.data.invoiceId;
    }

    this.CommonService.apiService(
      "POST",
      apiName,
      this.shippingData
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.dialogRef.close("success");
        }
        window.scrollTo(0, 0);

      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  onNoClick(): void {
    this.dialogRef.close();
  }


  getShippmentMethod = function () {
    this.loading = true;
    let shippingptions = {
      id: localStorage.getItem("userID"),
      invoice_id: this.data.invoiceId
    }

    this.CommonService.apiService(
      "POST",
      "shipping/methods",
      shippingptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          Object.entries(response.data).forEach(
            ([skey, value]) => {
              this.shippingMethods.push(
                {
                  key_value: skey,
                  name: value
                });
            });

        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );

  }

  selectShippingMethod(selectedShippingMethod) {

    if (selectedShippingMethod != "") {
      this.selectedMethod = selectedShippingMethod;
    }
    else {
      this.selectedMethod = "";

    }
  }

  quantityValidate = function (quantity) {
    if (quantity != '') {
      this.quantityError = parseInt(quantity) <= 0 ? true : false;
    }
    else {
      this.quantityError = true;
    }

  }
  printPage(labelUrl) {
    this.printLabelUrl = labelUrl;
    setTimeout(() => {
      window.print();

    }, 2000);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/shipping-info/shipping-info.component.ts